// removed by extract-text-webpack-plugin
module.exports = {"Event":"eventDesc__Event__3xYdK","EventDetails":"eventDesc__EventDetails__oGVBx"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Replayer/EventDesc/eventDesc.css
// module id = 1716
// module chunks = 2